import { Container, Tabs, Tab, Box, Stack, IconButton } from "@mui/material";
import { useState } from "react";

import { useVentas } from "./hooks/useVentas";

import POSVenta from "./POSVenta";
import DashboardDiario from "./DashboardDiario";
import EstadisticasVentas from "./EstadisticasVentas";
import HistorialVentas from "./HistorialVentas";
import ConfigRestaurante from "./ConfigRestaurante";
import SettingsIcon from "@mui/icons-material/Settings";
import FeedbackWA from "../FeedbackWA";

export default function FastFoodCore() {
  const [tab, setTab] = useState(0);
  const [openConfig, setOpenConfig] = useState(false);
  const state = useVentas();

  return (
    <Container sx={{ mt: 4, pb: 6 }}>
     <Stack direction="row" justifyContent="flex-end" mb={1}>
         <IconButton onClick={() => setOpenConfig(true)}>
             <SettingsIcon />
         </IconButton>
     </Stack>

      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="fullWidth"
        sx={{ mb: 3 }}
      >
        <Tab label="Vender" />
        <Tab label="Hoy" />
        <Tab label="Estadísticas" />
        <Tab label="Ventas" />
      </Tabs>

      <Box>
        {tab === 0 && <POSVenta state={state} />}
        {tab === 1 && <DashboardDiario state={state} />}
        {tab === 2 && <EstadisticasVentas state={state} />}
        {tab === 3 && <HistorialVentas state={state} />}
      </Box>

      <ConfigRestaurante
        state={state}
        open={openConfig}
        onClose={() => setOpenConfig(false)}
      />
      <FeedbackWA appName="POS Comida Rápida" />

    </Container>
  );
}